import { DateTime } from "luxon"

export const getGasDayRemaining = (tz: string, hour: number): number => {
  const now = DateTime.now().setZone(tz)
  const currentHour = now.hour
  let nextGasDay = now.startOf("day").plus({ hours: hour, days: 1 })

  if (currentHour < hour) {
    nextGasDay = nextGasDay.minus({ days: 1 })
  }

  return nextGasDay.diff(now, "hours").toObject().hours || 0
}
